<template>
  <div class="logo">
    <img :src="imgGd">
    <span class="site-name">{{ this.$i18n.messages[this.$i18n.locale].foot.s1 }}</span>
  </div>
</template>

<script>
import imgGd from '@/assets/images/logo.png';

export default {
  name: 'Logo',
  data() {
    return {
      imgGd
    }
  }
}
</script>

<style lang="less">
.logo {
  display: flex;
  justify-content: center;
  height: 130px;
  overflow: hidden;
  background: white;
  transition: all .3s;

  img {
    width: 59px;
    height: 58px;
    margin-left: 55px;
    margin-top: 36px;
    margin-bottom: 36px;
    margin-right: 20px;
  }

  .site-name {
    margin-top: 40px;
    margin-bottom: 48px;
    font-family: 'HiraginoSansGB', sans-serif;
    font-weight: normal;
    font-size: 31px;
    color: #006CB9;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/layouts/components/LayoutLogo/index.vue